const aboutText = [
  {
    about: "About us",
    aboutText:
      "WEGO transport is a modern company providing international freight transportation services in Europe.",
    vision: "Our vision",
    visionText:
      "It is open to innovation, appreciating partnership, and providing professional international cargo transportation services.",
    mission: "Our mission",
    missionText:
      "To provide the highest quality transportation services in accordance with customer requirements and needs in order to maximize their satisfaction and expectations, while respecting commitments to suppliers and employees, and focusing on the environment protection.",
    value: "Our values",
    valueTeam:
      "Teamwork – when each member of the organization understands that the best results can be achieved when everyone is acting together as one.",
    valuePartner:
      "Partnerships – we are focused, we seek and develop long term relationships with our customers, partners, employees, and this is the way of our business development.",
    valueInnovation:
      "Innovation – search for new opportunities and solutions to increase productivity and cost reduction by offering only the best deals to the customer.",
    valueEnvironment:
      "Environment protection – daily operations with minimal environmental impact.",
  },
  {
    about: "Apie mus",
    aboutText:
      "WEGO transport – tai moderni tarptautines krovinių gabenimo paslaugas Europoje teikianti įmonė.",
    vision: "Mūsų vizija",
    visionText:
      "Atvira naujovėms, partnerystę vertinanti, profesionalias krovinių gabenimo tarptautiniais maršrutais paslaugas teikianti įmonė.",
    mission: "Mūsų misija",
    missionText:
      "Teikti aukščiausios kokybės transporto paslaugas, atsižvelgiant ir įgyvendinant klientų reikalavimus bei siekiant maksimalaus jų poreikių ir lūkesčių patenkinimo, tuo pačiu laikantis įsipareigojimų tiekėjams bei darbuotojams ir orientuojantis į aplinkos apsaugą.",
    value: "Mūsų vertybės",
    valueTeam:
      "Komandinis darbas – kiekvienas organizacijos narys suvokia, kad geriausi rezultatai bus pasiekti veikiant kartu ir išvien.",
    valuePartner:
      "Partnerystė – orientuojamės, siekiame ir ugdome ilgalaikius santykius su klientais, partneriais, darbuotojais, tai mūsų įmonės veikos plėtros kelias.",
    valueInnovation:
      "Inovatyvumas – naujų galimybių ir sprendimų paieška produktyvumo didinimui ir sąnaudų mažinimui pateikiant klientui tik pačius geriausius pasiūlymus.",
    valueEnvironment:
      "Aplinkos apsauga – kasdienės veiklos vykdymas siekiant kiek įmanoma sumažinti poveikį aplinkai.",
  },
  {
    about: "O nas",
    aboutText:
      "WEGO transport – to nowoczesna firma świadcząca usługi transportu międzynarodowego towarów po Europie.",
    vision: "Nasza wizja",
    visionText:
      "Przedsiębiorstwo otwarte na nowości, ceniące partnerstwo, świadczące profesjonalne usługi przewozu towarów na trasach międzynarodowych.",
    mission: "Nasza misja",
    missionText:
      "Świadczenie usług transportowych najwyższej jakości, poprzez uwzględnianie i realizację wymagań klientów oraz dążenie do maksymalnego zadowolenia ich potrzeb i oczekiwań, także przestrzeganie zobowiązań wobec dostawców i pracowników oraz orientację na ochronę środowiska.",
    value: "Nasze wartości",
    valueTeam:
      "Praca zespołowa – każdy członek organizacji rozumie, że najlepsze wyniki osiąga się działając wspólnie i jednomyślnie.",
    valuePartner:
      "Partnerstwo – orientujemy się na długotrwałe relacje z klientami, partnerami, pracownikami oraz dążymy do ich utrzymania. Jest to droga rozwoju działalności naszej firmy.",
    valueInnovation:
      "Innowacyjność – poszukiwanie nowych możliwości i rozwiązań w celu zwiększenia wydajności oraz obniżenia kosztów, oferując klientom wyłącznie najlepsze rozwiązania.",
    valueEnvironment:
      "Ochrona środowiska – prowadzenie działalności z nastawieniem na maksymalne zmniejszenie wpływu na środowisko.",
  },
];

export default aboutText;
